export default __webpack_public_path__ + "static/media/VideoReel Logo.fcbddb39.jpg";